export const RUN_ENVIORNMENT = {
  0: 'UAT',
  1: 'PRODUCTION',
};

export const BASE_URL = window.location.origin;
export const IS_LOCALHOST =
  `http://localhost:${window.location.port}` === BASE_URL;

export const CURRENT_ENVIORMENT = RUN_ENVIORNMENT[0];

export const TWITTER_THREAD_UAT = [
  `http://localhost:${window.location.port}`,
  `https://localhost:${window.location.port}`,
];

export const TWITTER_THREAD_PRODUCTION = [
  `http://localhost:${window.location.port}`,
  `https://localhost:${window.location.port}`,
];

let API_URL = 'https://threadmagic.socialpilot.co';
if (TWITTER_THREAD_UAT.some(domain => domain === BASE_URL)) {
  // API_URL = 'http://localhost:4000';
  API_URL = 'https://threadmagic.socialpilot.co';
} else if (TWITTER_THREAD_PRODUCTION.some(domain => domain === BASE_URL)) {
  API_URL = 'https://newui-uat.socialpilot.co';
}

let socketEndPoint = 'https://uat-socket.socialpilot.co';
if (RUN_ENVIORNMENT === 'production') {
  socketEndPoint = 'https://app-socket.socialpilot.co';
}

export const API_BASE_URL = API_URL;
export const SOCKET_END_POINT = socketEndPoint;
